/**
 * A panel's title with its explanation behind an info icon.
 *
 * The explanation used to sit as a paragraph under the title on every board.
 * Read once it is useful; read on every visit it is clutter that pushes the
 * table down. It now rides on the icon as a tooltip, the same way a column's
 * derivation rides on its header, and the icon is a focusable button so the
 * keyboard reaches it too.
 */
import type { ReactNode } from "react";
import { CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { InfoHint } from "./info-hint";

export function PanelTitle({
  children,
  help,
  className,
}: {
  children: ReactNode;
  /** How this panel's figures are derived, in a sentence or two. */
  help?: string;
  className?: string;
}) {
  return (
    <CardTitle className={cn("flex items-center gap-1.5 font-display text-[14.5px]", className)}>
      {children}
      {help ? <InfoHint text={help} data-panel-help /> : null}
    </CardTitle>
  );
}
